module.exports = __webpack_public_path__ + "static/img/favicon.17fc242.ico";


//////////////////
// WEBPACK FOOTER
// ./static/favicon.ico
// module id = GyoY
// module chunks = 4